import React, { useState } from 'react';
import HomepageCategoryTile from './homepage_category_tile';
import HomepageSearchFilters from './homepage_search_filters';
import SparkleIcon from '../../images/homepage/sparkle.svg';
import TagIcon from '../../images/homepage/tag.svg';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import I18n from 'i18n-js';
import { Paths } from '../url_helpers';
import { useViewTracking } from '../use_tracking';
import { MParticleEventName } from '../elog/mparticle_types';
import { DISPLAY_CATEGORIES_TRANSLATION_KEYS } from './homepage/homepage_category_search_helpers';
import { upperFirst } from 'lodash';
import { useUser } from '../user_hooks';
import { formatExperimentsForEventAttributes } from '../elog/mparticle';
import experiments from '../experiments';

const DEFAULT_CATEGORY_TRANSLATION_KEY = 'electricGuitars';
const DEFAULT_SUBFILTER_TRANSLATION_KEY = 'allElectricGuitars';
const COMPONENT_NAME = 'HomepageCategorySearch';

export default function HomepageCategorySearch() {
  const [category, setCategory] = useState(DEFAULT_CATEGORY_TRANSLATION_KEY);
  const [subfilter, setSubfilter] = useState(DEFAULT_SUBFILTER_TRANSLATION_KEY);
  const user = useUser();

  useViewTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.NEW_HOMEPAGE_SEARCH_2,
    ]),
  }, true);

  const sellGearClickEvent = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ClickedHomepageSearchSellGearLink,
  };

  return (
    <div className="homepage-category-search">
      <div className="homepage-category-search__backsplash">

        <div className="homepage-category-search__backsplash-content">
          <div className="homepage-category-search__backsplash-heading">
            <h1>
              <strong>{I18n.t('commons.homepage.categorySearch.ifItsMusicGear')}</strong>
            </h1>
            <h2>{I18n.t('commons.homepage.categorySearch.searchMarketplace')}</h2>
          </div>
          <div className="homepage-category-search__backsplash-icons">
            <div className="homepage-category-search__find-gear">
              <img
                src={SparkleIcon}
                alt={I18n.t('commons.homepage.categorySearch.findGear')}
              />
              <h2>{I18n.t('commons.homepage.categorySearch.findGear')}</h2>
            </div>
            <div className="homepage-category-search__sell-gear">
              <img
                src={TagIcon}
                alt={I18n.t('commons.homepage.categorySearch.sellGear')}
              />
              <Translate
                html
                text="commons.homepage.categorySearch.turnIntoNew"
              >
                <CoreLink
                  to={Paths.sellGear.expand({})}
                  clickEvent={sellGearClickEvent}
                >
                  {I18n.t('commons.homepage.categorySearch.sellGear')}
                </CoreLink>
              </Translate>
            </div>
          </div>
        </div>
      </div>

      <div className="homepage-category-search__container">
        <div className="homepage-category-search__category-buttons">
          <div className="homepage-category-search__category-buttons-wrapper">
            {DISPLAY_CATEGORIES_TRANSLATION_KEYS.map(categoryTranslationKey => (
              <HomepageCategoryTile
                key={categoryTranslationKey}
                categoryTranslationKey={categoryTranslationKey}
                selectedCategory={category}
                onClick={() => {
                  // For whatever category tile we click, we want to autoselect the "All" filter
                  // e.g. if we're selecting 'electricGuitars', we want to set the subfilter to the translation
                  // key for that category's ALL filter - 'allElectricGuitars'
                  const allFilterTranslationKeyForCategory = `all${upperFirst(categoryTranslationKey)}`;
                  setSubfilter(allFilterTranslationKeyForCategory);
                  setCategory(categoryTranslationKey);
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {category &&
        <HomepageSearchFilters
          categoryTranslationKey={category}
          selectedSubfilterTranslationKey={subfilter}
          setSubfilter={setSubfilter}
        />
      }
    </div>
  );
}
